import {Dot} from "@/components/dot/Dot.tsx";

export const UnsavedIndicator = () => (
  <div className="d-flex align-items-center justify-content-center gap-1 flex-shrink-0">
    <Dot variant="orange" />
    <div className="text-center pulse-color-orange-600 pulseTextBodySmall">Unsaved</div>
  </div>
);
